// Validation d'e-mail côté client : un client qui saisit « ndeyefatou970icloud.com »
// paie puis ne reçoit jamais sa confirmation (Resend refuse l'adresse).
// Les fautes récupérables sont réparées automatiquement.
const EMAIL_RE = /^[^@\s]+@[^@\s.]+(\.[^@\s.]+)+$/;

const DOMAIN_TYPOS = {
    "gmai.com": "gmail.com", "gmial.com": "gmail.com", "gmail.co": "gmail.com",
    "gmail.con": "gmail.com", "gamil.com": "gmail.com", "gmaill.com": "gmail.com",
    "icloud.co": "icloud.com", "icloud.con": "icloud.com", "iclould.com": "icloud.com",
    "hotmai.com": "hotmail.com", "hotmial.com": "hotmail.com", "yahoo.co": "yahoo.com",
    "outlook.co": "outlook.com",
    // Domaine sans extension : « nom@gmail » → « nom@gmail.com »
    gmail: "gmail.com", icloud: "icloud.com", yahoo: "yahoo.com",
    hotmail: "hotmail.com", outlook: "outlook.com", live: "live.com",
};

const KNOWN_DOMAINS = [
    "gmail.com", "icloud.com", "yahoo.com", "yahoo.fr", "hotmail.com", "hotmail.fr",
    "outlook.com", "outlook.fr", "live.com", "live.fr", "orange.sn", "orange.fr",
    "me.com", "free.fr", "aol.com", "proton.me", "protonmail.com",
];

// Rétablit le « @ » oublié quand l'adresse finit par un domaine connu.
const repairMissingAt = (email) => {
    for (const domain of KNOWN_DOMAINS) {
        if (email.endsWith(domain)) {
            const local = email.slice(0, -domain.length).replace(/[.@]+$/, "");
            if (local) return `${local}@${domain}`;
        }
    }
    return email;
};

// Nettoie, répare, valide ; renvoie null si l'adresse reste inutilisable.
export const normalizeEmail = (value) => {
    if (!value) return null;
    let email = String(value).trim().replace(/\s+/g, "").replace(/\.+$/, "").toLowerCase();
    if (!email.includes("@")) email = repairMissingAt(email);
    const at = email.lastIndexOf("@");
    if (at > 0) {
        const domain = email.slice(at + 1);
        email = `${email.slice(0, at)}@${DOMAIN_TYPOS[domain] || domain}`;
    }
    return EMAIL_RE.test(email) ? email : null;
};
